import DataGridColumn from './DataGridColumn';
import DataGridStyleOptions from './DataGridStyleOptions';

export default class DataGridOptions {
    public EntityType: number = 0;
    public EntityVariation: number = 0;
    public Columns: DataGridColumn[] = [];
    public EntityEditForm: string = '';
    public EntityDetailsForm: string = '';
    public MethodEndpoint: string = '';
    public DeleteMethodEndpoint: string = '';
    public EntityName: string = '';
    public HasDelete: boolean = false;
    public HasEdit: boolean = false;
    public HasDetails: boolean = false;
    public ShowHeader: boolean = true;
    public ShowActions: boolean = true;
    public Styles: DataGridStyleOptions = new DataGridStyleOptions();
    public SimpleSearch: boolean = false;
    public ServerLoad: boolean = true;
    public GridData: any[] = [];
    public UrlRouting: string = '';

    public PageSize: number = 50;
    public VirtualScrolling: boolean = false;
    public RowSelection: boolean = false;
}
